import { useEffect, useState } from 'react'
import { HashLink } from 'react-router-hash-link'
import axios from 'axios'
import ReactGA from 'react-ga4'

import { ButtonDecoSmall, ButtonLineSmall, ButtonRetailer } from '../utility/Buttons'

export const Products = () => {
    const gameData = {
        path: 'phantombrave-the-lost-hero',
        // steam: '1998340',
    }

    const imagePath = {
        'PlayStation®5': 'ps5',
        'PlayStation®4': 'ps4',
        Xbox: 'xbox',
        'Nintendo Switch™': 'nsw',
    }
    const digitalEdition = [
        {
            console: 'PlayStation®5',
            region: 'North America',
            standardEditionlink: 'https://store.playstation.com/en-us/product/UP1063-PPSA21029_00-PHANTOMBRAVE2001',
            deluxeEditionLink: 'https://store.playstation.com/en-us/product/UP1063-PPSA21029_00-0847963823758140',
            special: 'putumia',
        },
        {
            console: 'PlayStation®5',
            region: 'Europe',
            standardEditionlink: 'https://store.playstation.com/en-gb/product/EP1063-PPSA21030_00-PHANTOMBRAVE2001',
            deluxeEditionLink: 'https://store.playstation.com/en-gb/product/EP1063-PPSA21030_00-0816460646246953',
            special: 'putumia',
        },
        {
            console: 'PlayStation®4',
            region: 'North America',
            standardEditionlink: 'https://store.playstation.com/en-us/product/UP1063-PPSA21029_00-PHANTOMBRAVE2001',
            deluxeEditionLink: 'https://store.playstation.com/en-us/product/UP1063-PPSA21029_00-0847963823758140',
            special: 'putumia',
        },
        {
            console: 'PlayStation®4',
            region: 'Europe',
            standardEditionlink: 'https://store.playstation.com/en-gb/product/EP1063-PPSA21030_00-PHANTOMBRAVE2001',
            deluxeEditionLink: 'https://store.playstation.com/en-gb/product/EP1063-PPSA21030_00-0816460646246953',
            special: 'putumia',
        },
        {
            console: 'Nintendo Switch™',
            region: 'North America',
            standardEditionlink: 'Coming Soon',
            deluxeEditionLink: 'Coming Soon',
            special: '',
        },
        {
            console: 'Nintendo Switch™',
            region: 'Europe',
            standardEditionlink: 'Coming Soon',
            deluxeEditionLink: 'Coming Soon',
            special: '',
        },
    ]

    const [editions, setEditions] = useState([])
    const [data, setData] = useState([])
    const [activeCharTab, setActiveCharTab] = useState('limited')
    const [platformDeluxe, setPlatformDeluxe] = useState('Nintendo Switch™')
    const [platformDigital, setPlatformDigital] = useState('PlayStation®5')

    const FilterRegion = (region, platform) =>
        data.filter((item) => item.region === region && item.edition === 'Deluxe Edition' && item.platform === platform)
    const FilterDigitalRegion = (region, platform) =>
        data.filter((item) => item.region === region && item.edition === 'Deluxe Edition' && item.platform === platform)
    const filteredEditions = digitalEdition.filter((item) => item.console === platformDigital)

    const FilterRegionEdition = (region, platform, edition) =>
        data.filter((item) => item.region === region && item.edition === edition && item.platform === platform)
    const platformReduced = Object.values(data).reduce((acc, curr) => {
        if (curr.platform !== 'PC' && curr.platform !== 'Xbox One' && !acc.includes(curr.platform)) {
            acc.push(curr.platform)
        }
        return acc
    }, [])
    useEffect(() => {
        axios
            .get(`https://www.nisamerica.com/api/game/${gameData.path}`)
            .then((response) => {
                const editions = Object.values(response.data.game.retailerLinks.map((item) => item.edition))
                const data = response.data.game.retailerLinks.map((item) => {
                    return {
                        url: item.url,
                        store: item.store,
                        edition: item.edition,
                        platform: item.platform,
                        region: item.region,
                    }
                })

                setEditions(editions)
                setData(data)
            })
            .catch((error) => {
                console.log(error)
            })
    }, [])
    return (
        <>
            <div className='md:pt-0 md:mt-20 max-w-[1200px] mx-auto'>
                <div className='py-12 w-full text-center mx-auto'>
                    
                    <span className=' relative pt-2'>
                        <h1 className='md:hidden text-gradient-title text-xlg font-pop inline-block'>Products</h1>{' '}
                    </span>
                </div>{' '}
                <div className='flex flex-wrap justify-evenly gap-1 mt-12 md:mt-0 px-2 mx-auto'>
                    <div className='max-w-[280px] w-[48%] md:w-[24%]'>
                        <HashLink to='#demo' activeclassname='active'>
                            <button>
                                <span className='relative inline-block'>
                                    <img
                                        onClick={() => {
                                            setActiveCharTab('demo')
                                        }}
                                        className={`${
                                            activeCharTab === 'demo' && ''
                                        } hover:brightness-150 duration-300 mx-auto`}
                                        src={`${process.env.PUBLIC_URL}/images/products/header-demo.webp`}
                                        alt='products'
                                    />{' '}
                                </span>
                            </button>{' '}
                        </HashLink>
                    </div>{' '}
                    <div className='max-w-[280px] w-[48%] md:w-[24%]'>
                        <HashLink to='#ltdedition' activeclassname='active'>
                            <button>
                                <span className='relative inline-block'>
                                    <img
                                        onClick={() => {
                                            setActiveCharTab('limited')
                                        }}
                                        className={`${
                                            activeCharTab === 'limited' && ''
                                        } hover:brightness-150 duration-300 mx-auto`}
                                        src={`${process.env.PUBLIC_URL}/images/products/header-limited-edition.webp`}
                                        alt='products'
                                    />{' '}
                                </span>
                            </button>{' '}
                        </HashLink>
                    </div>{' '}
                    <div className='max-w-[280px] w-[48%] md:w-[24%]'>
                        <HashLink to='#dlxedition' activeclassname='active'>
                            <button>
                                <span className='relative inline-block'>
                                    <img
                                        onClick={() => {
                                            setActiveCharTab('deluxe')
                                        }}
                                        className={`${
                                            activeCharTab === 'deluxe' && ''
                                        } hover:brightness-150 duration-300 mx-auto`}
                                        src={`${process.env.PUBLIC_URL}/images/products/header-deluxe-edition.webp`}
                                        alt='products'
                                    />{' '}
                                </span>
                            </button>{' '}
                        </HashLink>
                    </div>{' '}
                    <div className='max-w-[280px] w-[48%] md:w-[24%]'>
                        <HashLink to='#digitaledition' activeclassname='active'>
                            <button>
                                <span className='relative inline-block '>
                                    <img
                                        onClick={() => {
                                            setActiveCharTab('digital')
                                        }}
                                        className={`${
                                            activeCharTab === 'digital' && ''
                                        } hover:brightness-150 duration-300 mx-auto`}
                                        src={`${process.env.PUBLIC_URL}/images/products/header-digital-edition.webp`}
                                        alt='products'
                                    />{' '}
                                </span>
                            </button>{' '}
                        </HashLink>
                    </div>{' '}
                </div>{' '}
                <section id='demo' className='my-28 md:mb-40 md:mt-32  mx-auto section-deco'>
                    {' '}
                    <div className='flex justify-center '>
                        <img
                            className=''
                            alt='limited edition'
                            src={`${process.env.PUBLIC_URL}/images/products/products-header-demo.webp`}
                        />
                    </div>{' '}
                    <div className='max-w-[1000px] flex flex-wrap justify-evenly mx-auto gap-2 px-4 my-20'>
                        <div className='w-[48%] md:w-[31%] mx-auto text-center'>
                            <button>
                                <a
                                    target='_blank'
                                    rel='noreferrer'
                                    onClick={() => {
                                        ReactGA.event({
                                            action: 'click',
                                            event: 'link',
                                            category: 'Product',
                                            label: 'Demo - NSW - Nintendo',
                                        })
                                    }}
                                    href='https://www.nintendo.com/us/store/products/phantom-brave-the-lost-hero-switch/'
                                >
                                    <img
                                        className='max-w-[240px] mx-auto w-full'
                                        alt='Demo nsw'
                                        src={`${process.env.PUBLIC_URL}/images/products/btn_switch.png`}
                                    />{' '}
                                </a>
                            </button>{' '}
                        </div>{' '}
                        <div className='w-[48%] md:w-[31%] mx-auto text-center'>
                            <button>
                                <a
                                    target='_blank'
                                    rel='noreferrer'
                                    onClick={() => {
                                        ReactGA.event({
                                            action: 'click',
                                            event: 'link',
                                            category: 'Product',
                                            label: 'Demo - PS5 - PSN',
                                        })
                                    }}
                                    href='https://store.playstation.com/en-us/product/UP1063-PPSA26643_00-PB2DEMO000000001'
                                >
                                    <img
                                        className='max-w-[240px] mx-auto w-full'
                                        alt='Demo ps5'
                                        src={`${process.env.PUBLIC_URL}/images/products/btn_ps5.png`}
                                    />{' '}
                                </a>
                            </button>
                        </div>{' '}
                        <div className='w-[48%] md:w-[31%] mx-auto text-center'>
                            <button>
                                <a
                                    target='_blank'
                                    rel='noreferrer'
                                    onClick={() => {
                                        ReactGA.event({
                                            action: 'click',
                                            event: 'link',
                                            category: 'Product',
                                            label: 'Demo - PS4 - PSN',
                                        })
                                    }}
                                    href='https://store.playstation.com/en-us/product/UP1063-PPSA26643_00-PB2DEMO000000001'
                                >
                                    <img
                                        className='max-w-[240px] mx-auto w-full'
                                        alt='Demo ps4'
                                        src={`${process.env.PUBLIC_URL}/images/products/btn_ps4.png`}
                                    />{' '}
                                </a>
                            </button>{' '}
                        </div>
                    </div>
                </section>
                <section id='ltdedition' className='md:pb-20 mx-auto section-deco'>
                    {' '}
                    <div className='flex justify-center mt-20'>
                        <img
                            className=''
                            alt='limited edition'
                            src={`${process.env.PUBLIC_URL}/images/products/products-header-limited.webp`}
                        />
                    </div>{' '}
                    <img
                        className='w-4/5 mx-auto max-w-[800px] my-12'
                        alt='limited edition'
                        src={`${process.env.PUBLIC_URL}/images/products/le-nsw.webp`}
                    />{' '}
                    <div className='max-w-[1000px] flex flex-wrap justify-evenly mx-auto gap-2 px-4'>
                        <div className='w-[48%] md:w-[31%] mx-auto text-center'>
                            <button>
                                <a
                                    target='_blank'
                                    rel='noreferrer'
                                    onClick={() => {
                                        ReactGA.event({
                                            action: 'click',
                                            event: 'link',
                                            category: 'Product',
                                            label: 'Limited Ediiton - NSW - NISA Online Store',
                                        })
                                    }}
                                    href='https://store.nisamerica.com/products/phantom-brave-the-lost-hero?variant=41658788937776'
                                >
                                    <img
                                        className='max-w-[240px] mx-auto w-full'
                                        alt='limited edition nsw'
                                        src={`${process.env.PUBLIC_URL}/images/products/btn_switch.png`}
                                    />{' '}
                                </a>
                            </button>{' '}
                        </div>{' '}
                        <div className='w-[48%] md:w-[31%] mx-auto text-center'>
                            <button>
                                <a
                                    target='_blank'
                                    rel='noreferrer'
                                    onClick={() => {
                                        ReactGA.event({
                                            action: 'click',
                                            event: 'link',
                                            category: 'Product',
                                            label: 'Limited Ediiton - PS5 - NISA Online Store',
                                        })
                                    }}
                                    href='https://store.nisamerica.com/products/phantom-brave-the-lost-hero?variant=41658788970544'
                                >
                                    <img
                                        className='max-w-[240px] mx-auto w-full'
                                        alt='limited edition ps5'
                                        src={`${process.env.PUBLIC_URL}/images/products/btn_ps5.png`}
                                    />{' '}
                                </a>
                            </button>
                        </div>{' '}
                        <div className='w-[48%] md:w-[31%] mx-auto text-center'>
                            <button>
                                <a
                                    target='_blank'
                                    rel='noreferrer'
                                    onClick={() => {
                                        ReactGA.event({
                                            action: 'click',
                                            event: 'link',
                                            category: 'Product',
                                            label: 'Limited Ediiton - PS4 - NISA Online Store',
                                        })
                                    }}
                                    href='https://store.nisamerica.com/products/phantom-brave-the-lost-hero?variant=41658789003312'
                                >
                                    <img
                                        className='max-w-[240px] mx-auto w-full'
                                        alt='limited edition ps4'
                                        src={`${process.env.PUBLIC_URL}/images/products/btn_ps4.png`}
                                    />{' '}
                                </a>
                            </button>{' '}
                        </div>
                    </div>
                </section>
                <section id='dlxedition' className='md:pb-20 mx-auto section-deco'>
                    <div className='flex justify-center mt-20'>
                        <img
                            className=''
                            alt='deluxe edition'
                            src={`${process.env.PUBLIC_URL}/images/products/products-header-deluxe.png`}
                        />
                    </div>{' '}
                    <div className='mx-auto mt-12 md:mt-20'>
                        <div className='flex flex-col lg:flex-row lg:mx-12 lg:space-x-8'>
                            <div className='w-full lg:w-1/4 pb-8 lg:pb-20 flex flex-wrap lg:flex-col lg:space-y-4 justify-center lg:justify-start'>
                                <ButtonDecoSmall
                                    onClickEvent={() => setPlatformDeluxe('Nintendo Switch™')}
                                    active={platformDeluxe === 'Nintendo Switch™'}
                                >
                                    Nintendo Switch™
                                </ButtonDecoSmall>{' '}
                                <ButtonDecoSmall
                                    onClickEvent={() => setPlatformDeluxe('PlayStation®5')}
                                    active={platformDeluxe === 'PlayStation®5'}
                                >
                                    PlayStation®5
                                </ButtonDecoSmall>{' '}
                                <ButtonDecoSmall
                                    onClickEvent={() => setPlatformDeluxe('PlayStation®4')}
                                    active={platformDeluxe === 'PlayStation®4'}
                                >
                                    PlayStation®4
                                </ButtonDecoSmall>{' '}
                                {/* <ButtonDecoSmall
                                    onClickEvent={() => setPlatformDeluxe('Steam®')}
                                    active={platformDeluxe === 'Steam®'}
                                >
                                    Steam®
                                </ButtonDecoSmall>{' '} */}
                            </div>
                            {/* {platformDeluxe === 'Steam®' ? (
                                <div className='md:px-12 w-full'>
                                    <iframe
                                        title='phantom brave the lost hero'
                                        src='https://store.steampowered.com/widget/3049990/'
                                        style={{ maxWidth: '900px' }}
                                        frameBorder='0'
                                        width='100%'
                                        height='190'
                                        onClick={() => {
                                            ReactGA.event({
                                                action: 'click',
                                                event: 'link',
                                                category: 'Product',
                                                label: 'Deluxe Ediiton - PC - Steam',
                                            })
                                        }}
                                    ></iframe>{' '}
                                </div>
                            ) : ( */}
                            <div className='w-full lg:w-3/4 px-4 pb-8'>
                                <img
                                    className='max-h-[500px] mx-auto'
                                    src={`${process.env.PUBLIC_URL}/images/products/de-${imagePath[platformDeluxe]}.webp`}
                                    alt={`Deluxe Edition ${imagePath[platformDeluxe]}`}
                                />
                                <div className='text-center mt-4'>
                                    <div className=''>
                                        <ButtonLineSmall text='North America' />{' '}
                                        <div className='flex flex-wrap justify-evenly md:justify-around md:gap-4 font-humming'>
                                            {' '}
                                            {FilterRegion('NA', platformDeluxe).map((data, i) => (
                                                <div className='w-[45%] md:w-[23%] lg:w-[22%] mt-2 md:mt-0'>
                                                    <ButtonRetailer
                                                        dataPlatform={data.platform}
                                                        dataUrl={data.url}
                                                        dataStore={data.store}
                                                        gaCategory='Products'
                                                        gaLabel={`Deluxe Edition - ${data.platform} - ${data.store}`}
                                                    />{' '}
                                                </div>
                                            ))}
                                        </div>
                                    </div>{' '}
                                    <div className='mt-4'>
                                        <ButtonLineSmall text='Europe' />{' '}
                                        <div className='flex flex-wrap justify-evenly md:justify-around md:gap-4 font-sans'>
                                            {FilterRegion('EU', platformDeluxe).map((data, i) => (
                                                <div className='w-[45%] md:w-[23vw] lg:w-[28%] mt-2 md:mt-0'>
                                                    <ButtonRetailer
                                                        dataPlatform={data.platform}
                                                        dataUrl={data.url}
                                                        dataStore={data.store}
                                                        gaCategory='Products'
                                                        gaLabel={`Deluxe Edition - ${data.platform} - ${data.store}`}
                                                    />{' '}
                                                </div>
                                            ))}
                                        </div>
                                    </div>{' '}
                                    {FilterRegion('ANZ', platformDeluxe).length > 0 && (
                                        <div className='mt-4'>
                                            <ButtonLineSmall text='Oceania' />
                                            <div className='flex flex-wrap justify-evenly md:justify-around md:gap-4 font-sans'>
                                                {FilterRegion('ANZ', platformDeluxe).map((data, i) => (
                                                    <div
                                                        className='w-[45%] md:w-[23vw] lg:w-[28%] mt-2 md:mt-0'
                                                        key={i}
                                                    >
                                                        <ButtonRetailer
                                                            dataPlatform={data.platform}
                                                            dataUrl={data.url}
                                                            dataStore={data.store}
                                                            gaCategory='Products'
                                                            gaLabel={`Deluxe Edition - ${data.platform} - ${data.store}`}
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            {/* )} */}
                        </div>
                    </div>
                </section>{' '}
                <section id='digitaledition' className='md:my-20 md:pb-20 mx-auto section-deco'>
                    <div className='flex justify-center mt-20'>
                        <img
                            className=''
                            alt='deluxe edition'
                            src={`${process.env.PUBLIC_URL}/images/products/products-header-digital.webp`}
                        />
                    </div>{' '}
                    <div className='mx-auto mt-12 md:mt-20'>
                        <div className='flex flex-col lg:flex-row lg:mx-12 lg:space-x-8'>
                            <div className='w-full lg:w-1/4 pb-8 lg:pb-20 flex flex-wrap lg:flex-col lg:space-y-4 justify-center lg:justify-start'>
                                <ButtonDecoSmall
                                    onClickEvent={() => setPlatformDigital('Nintendo Switch™')}
                                    active={platformDigital === 'Nintendo Switch™'}
                                >
                                    Nintendo Switch™
                                </ButtonDecoSmall>{' '}
                                <ButtonDecoSmall
                                    onClickEvent={() => setPlatformDigital('PlayStation®5')}
                                    active={platformDigital === 'PlayStation®5'}
                                >
                                    PlayStation®5
                                </ButtonDecoSmall>{' '}
                                <ButtonDecoSmall
                                    onClickEvent={() => setPlatformDigital('PlayStation®4')}
                                    active={platformDigital === 'PlayStation®4'}
                                >
                                    PlayStation®4
                                </ButtonDecoSmall>{' '}
                                <ButtonDecoSmall
                                    onClickEvent={() => setPlatformDigital('Steam®')}
                                    active={platformDigital === 'Steam®'}
                                >
                                    Steam®
                                </ButtonDecoSmall>{' '}
                            </div>
                            {platformDigital === 'Steam®' ? (
                                <div className='w-full lg:w-3/4 px-4 pb-8 text-center'>
                                    <iframe
                                        title='phantom brave the lost hero'
                                        src='https://store.steampowered.com/widget/3049990/'
                                        style={{ maxWidth: '900px' }}
                                        frameBorder='0'
                                        width='100%'
                                        height='190'
                                        onClick={() => {
                                            ReactGA.event({
                                                action: 'click',
                                                event: 'link',
                                                category: 'Product',
                                                label: 'Deluxe Ediiton - PC - Steam',
                                            })
                                        }}
                                    ></iframe>{' '}
                                </div>
                            ) : platformDigital === 'Nintendo Switch™' ? (
                                <div className='w-full lg:w-3/4 px-4 pb-8 text-center'>
                                    <ButtonLineSmall text='North America' />{' '}
                                    <p className='font-humming text-shadow-white font-bold  text-sm md:text-base my-12'>
                                        Coming Soon
                                    </p>{' '}
                                    <ButtonLineSmall text='Europe' />
                                    <p className='font-humming text-shadow-white font-bold  text-sm md:text-base my-12'>
                                        Coming Soon
                                    </p>
                                </div>
                            ) : (
                                <div className='w-full lg:w-3/4 px-4 pb-8'>
                                    <div className='text-center '>
                                        <div className=''>
                                            <img
                                                className='max-h-[500px] mx-auto border-0 border-pbbrown'
                                                src={`${process.env.PUBLIC_URL}/images/products/putumia.webp`}
                                                alt={`Digital Edition ${platformDigital}`}
                                            />{' '}
                                            <div className='my-12'>
                                                <p className='font-humming text-shadow-white font-bold text-sm'>
                                                    Preorders receive the Exclusive Putty Outfit -{' '}
                                                    <span className='text-pborange'>Putumia</span>!
                                                </p>
                                                <p className='font-humming text-shadow-white font-bold text-caption mt-4'>
                                                    *Digital preorders for{' '}
                                                    {platformDigital === 'PlayStation®5' ? 'PS5' : 'PS4'} are cross-buy
                                                    and will also receive the{' '}
                                                    {platformDigital === 'PlayStation®5' ? 'PS4' : 'PS5'} version
                                                </p>
                                            </div>
                                            <ButtonLineSmall text='North America' />
                                            <div className=' font-humming'>
                                                {filteredEditions
                                                    .filter((item) => item.region === 'North America')
                                                    .map((item, i) => (
                                                        <div key={i} className='mb-2'>
                                                            <div className='flex flex-row gap-2'>
                                                                <ButtonRetailer
                                                                    dataPlatform={item.console}
                                                                    dataUrl={item.standardEditionlink}
                                                                    dataStore='Standard Edition'
                                                                    gaCategory='Products'
                                                                    gaLabel={`Standard Edition - ${item.console}`}
                                                                />{' '}
                                                                <ButtonRetailer
                                                                    dataPlatform={item.console}
                                                                    dataUrl={item.deluxeEditionLink}
                                                                    dataStore='Deluxe Edition'
                                                                    gaCategory='Products'
                                                                    gaLabel={`Deluxe Edition - ${item.console}`}
                                                                />
                                                            </div>
                                                        </div>
                                                    ))}
                                            </div>{' '}
                                            <ButtonLineSmall text='Europe' />
                                            <div className='font-humming'>
                                                {filteredEditions
                                                    .filter((item) => item.region === 'Europe')
                                                    .map((item, i) => (
                                                        <div key={i} className='mb-2'>
                                                            <div className='flex flex-row gap-2'>
                                                                <ButtonRetailer
                                                                    dataPlatform={item.console}
                                                                    dataUrl={item.standardEditionlink}
                                                                    dataStore='Standard Edition'
                                                                    gaCategory='Products'
                                                                    gaLabel={`Standard Edition - ${item.console}`}
                                                                />{' '}
                                                                <ButtonRetailer
                                                                    dataPlatform={item.console}
                                                                    dataUrl={item.deluxeEditionLink}
                                                                    dataStore='Deluxe Edition'
                                                                    gaCategory='Products'
                                                                    gaLabel={`Deluxe Edition - ${item.console}`}
                                                                />
                                                            </div>
                                                        </div>
                                                    ))}
                                            </div>
                                        </div>{' '}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </section>{' '}
            </div>
        </>
    )
}
